import { render, staticRenderFns } from "./PivotOrder.vue?vue&type=template&id=c6652056&scoped=true"
import script from "./PivotOrder.vue?vue&type=script&lang=js"
export * from "./PivotOrder.vue?vue&type=script&lang=js"
import style0 from "./PivotOrder.vue?vue&type=style&index=0&id=c6652056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6652056",
  null
  
)

export default component.exports